import React, { FC } from 'react';
import classNames from 'classnames';

import { LoaderIconAnimation } from 'Src/components/icons/LoaderIconAnimation';
import { useImageLoader } from 'Src/feature/image/useImageLoader';

import styles from './Image.module.scss';

interface ImageProps {
  loader: ReturnType<typeof useImageLoader>;
  className?: string;
}

const Image: FC<ImageProps> = ({ loader, className }) => (
  <div
    className={classNames(styles.root, className, {
      [styles.is_loading]: loader.isLoading,
      [styles.is_error]: loader.hasError,
      [styles.is_valid]: loader.isValid,
    })}
  >
    <img
      className={styles.img}
      src={loader?.src}
      alt={loader.image.alt}
    />
    <LoaderIconAnimation className={styles.loading_icon} />
  </div>
);

export { Image };
export type { ImageProps };
